import React, {Component} from 'react';
import {Redirect, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import {restoreSession} from '../auth';
import {Footer} from './shared';

class PrivateRoute extends Component {
	constructor(props) {
		super(props);
		const noUser = !props.currentUser || props.currentUser.email == undefined;
		this.state = { checkingSession: noUser };
	}

	componentDidMount() {
		if (this.props.currentUser.email == undefined) {
			restoreSession().finally(() => this.setState({ checkingSession: false }));
		} else {
			this.setState({ checkingSession: false });
		}
	}

	render() {
		const {component: Component, layout: Layout, currentUser, location, footer, ...rest} = this.props;
		const { checkingSession } = this.state;

		if (checkingSession) {
			return null;
		}
		if (currentUser.email == undefined) {
			return <Redirect to={{pathname: '/login', state: {from: location}}} />;
		}

		return (
			<Route
				{...rest}
				render={(props) => (
					<Layout>
						<Component {...props} />
						{footer && <Footer />}
					</Layout>
				)}
			/>
		);
	}
}

const mapStateToProps = ({userStore}) => {
	return {
		currentUser: userStore.currentUser
	};
};

export default connect(mapStateToProps)(PrivateRoute);
